module.exports = __webpack_public_path__ + "media/blog/copy-f36e7df2.png";